import { EditionAwarenessContextType } from './edition-awareness-context';

type ConfluenceBuyReverseTrialsExperimentEligibility = {
	context: EditionAwarenessContextType;
};

export function isEligibleForConfluenceBuyReverseTrialExperiment({
	context,
}: ConfluenceBuyReverseTrialsExperimentEligibility): boolean {
	const {
		product,
		edition,
		isInvoiceable,
		isInReverseTrial,
		isInTrial,
		isInPredunning,
		billingSourceSystem,
	} = context;

	return Boolean(
		product === 'confluence' &&
			edition === 'premium' &&
			(isInTrial || isInPredunning) &&
			isInReverseTrial &&
			isInvoiceable === false &&
			billingSourceSystem === 'CCP',
	);
}
